<template>
  <box-model title="地块种植情况">
    <template v-slot:content>
      <div class="con">
        <div class="c-item flex-y-center">
          <div class="img flex-center">
            <img class="i-img" src="../../assets/img/massif-3.png" />
          </div>
          <div class="detail">
            <div class="num flex-y-center">
              <span class="txt" :class="(detail.farmlandNum + '').length > 5  ?'txt-size-mini':''">{{ detail.farmlandNum || 0 }}</span>
              <div class="t-line"></div>
            </div>
            <div class="name">地块总数</div>
          </div>
        </div>
        <div class="c-item flex-y-center">
          <div class="img flex-center">
            <img class="i-img" src="../../assets/img/massif-2.png" />
          </div>
          <div class="detail">
            <div class="num flex-y-center">
              <span class="txt" :class="(detail.plantingNum + '').length > 5  ?'txt-size-mini':''">{{ detail.plantingNum || 0 }}</span>
              <div class="t-line"></div>
            </div>
            <div class="name">种植中</div>
          </div>
        </div>
        <div class="c-item flex-y-center">
          <div class="img flex-center">
            <img class="i-img" src="../../assets/img/massif-1.png" />
          </div>
          <div class="detail">
            <div class="num flex-y-center">
              <span class="txt" :class="(detail.idleNum + '').length > 5  ?'txt-size-mini':''">{{ detail.idleNum || 0 }}</span>
              <div class="t-line"></div>
            </div>
            <div class="name">闲置</div>
          </div>
        </div>
        <div class="c-item flex-y-center">
          <div class="img flex-center">
            <img class="i-img" src="../../assets/img/massif-6.png" />
          </div>
          <div class="detail">
            <div class="num flex-y-center">
              <span class="txt" :class="(detail.totalArea + '').length > 5  ?'txt-size-mini':''">{{ detail.totalArea || 0 }}</span>
              <div class="t-line"></div>
            </div>
            <div class="name">面积(亩)</div>
          </div>
        </div>
        <div class="c-item flex-y-center">
          <div class="img flex-center">
            <img class="i-img" src="../../assets/img/massif-5.png" />
          </div>
          <div class="detail">
            <div class="num flex-y-center">
              <span class="txt" :class="(detail.plantingArea + '').length > 5  ?'txt-size-mini':''">{{ detail.plantingArea || 0 }}</span>
              <div class="t-line"></div>
            </div>
            <div class="name" style="font-size: 11px;">种养面积(亩)</div>
          </div>
        </div>
        <div class="c-item flex-y-center">
          <div class="img flex-center">
            <img class="i-img" src="../../assets/img/massif-4.png" />
          </div>
          <div class="detail">
            <div class="num flex-y-center">
              <span class="txt" :class="(detail.breedingVarietyNum + '').length > 5  ?'txt-size-mini':''">{{ detail.breedingVarietyNum || 0 }}</span>
              <div class="t-line"></div>
            </div>
            <div class="name">种养品种</div>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import { getTotalData } from "@/api/index";
  export default {
    data() {
      return {
        detail: {}
      }
    },
    components: {
      "box-model": () => import("../../components/common/Model.vue")
    },
    mounted() {
      this.getTotalDataEvent();
    },
    methods: {
      getTotalDataEvent(){
        getTotalData().then((res) => {
          this.detail = res.data || {};
        })
      }
    }
  }
</script>
<style scoped lang="less">
  .con {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 218px;
    .c-item {
      width: 33.33%;
      height: 48px;
      .img {
        width: 48px;
        height: 48px;
        margin-right: 8px;
        .i-img {
          width: 32px;
          height: 32px;
        }
      }
      .detail {
        width: 64px;
        height: 100%;
        .num {
          position: relative;
          width: 64px;
          height: 26px;
          padding-left: 4px;
          .txt {
            position: relative;
            z-index: 3;
            font-size: 26px;
            font-weight: 700;
            color: #FFFFFF;
          }
          .txt-size-mini {
            font-size: 18px;
          }
          .t-line {
            position: absolute;
            z-index: 0;
            left: 0;
            bottom: 0;
            width: 48px;
            height: 12px;
            background: linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
            opacity: 0.16;
          }
        }
        .name {
          font-size: 18px;
          font-weight: 400;
          color: rgba(255,255,255,0.7);
          line-height: 18px;
          margin-top: 8px;
        }
      }
    }
  }
</style>